import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";

/**
 * Star icon for the rating.
 * @returns Solid star icon.
 */
const FilledStar = () => <FontAwesomeIcon icon={faStar} size="lg" />;

export default FilledStar;
